import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a408c61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "honorbox flex f-d a-c" }
const _hoisted_2 = {
  key: 0,
  class: "honnerList flex f-d a-c"
}
const _hoisted_3 = { class: "honer-self flex f-d j-s-b" }
const _hoisted_4 = { class: "honor-title" }
const _hoisted_5 = { class: "honor-content" }
const _hoisted_6 = { class: "honor-img flex a-c j-e" }
const _hoisted_7 = {
  key: 1,
  class: "honnerList"
}

import { onMounted, ref, watch } from "vue";
import CheckType from "@/utils/CheckType";
import Padding from "@/components/Layout/paging.vue";
import NotYetOpen from "@/components/NotYetOpen.vue";
// import PerchUtil from "@/utils/Perch";

export default /*#__PURE__*/_defineComponent({
  __name: 'Honor',
  props: {
    honorList: null
  },
  emits: ["issuehonor"],
  setup(__props: any, { emit }) {

const props = __props as { honorList };

const newData = ref([]);

let honorList = ref([]);

const getDataOne = (data) => {
  newData.value = data;
};

const getList = () => {
  honorList.value.splice(0, honorList.value.length);
  honorList.value.push(...props.honorList);
};
watch(
  () => {
    return props.honorList.length;
  },
  () => {
    getList();
  }
);
// import NotYetOpen from "@/components/NotYetOpen.vue";

const issuehonor = () => {
  // 2为发布荣誉
  emit("issuehonor");
};
onMounted(() => {
  getList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (issuehonor()))
    }, {
      default: _withCtx(() => [
        _createTextVNode("发布一个新的荣誉")
      ]),
      _: 1
    }),
    (_unref(honorList).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newData.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "honor flex j-s-e a-c",
              key: index
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h1", _hoisted_4, "标题：" + _toDisplayString(item.title), 1),
                _createElementVNode("p", _hoisted_5, "内容：" + _toDisplayString(item.content), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (item.picture)
                  ? (_openBlock(), _createBlock(_component_el_image, {
                      key: 0,
                      class: "case-img",
                      src: item.picture,
                      "preview-src-list": [_unref(CheckType).isImg(item.picture)],
                      fit: "cover"
                    }, null, 8, ["src", "preview-src-list"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(NotYetOpen, { data: "暂无内容哦!" })
        ])),
    _withDirectives(_createVNode(Padding, {
      data: _unref(honorList),
      "page-size": 3,
      onGetData: getDataOne
    }, null, 8, ["data"]), [
      [_vShow, _unref(honorList).length > 0]
    ])
  ]))
}
}

})